"use client";
import React, { useEffect, useRef, useState } from "react";
import { Checkbox } from "@mui/material";
import { VeBox, VeTypography, useMediaQuery } from "../../../mui";
import {
  RemoveIcon,
  VeDatePicker,
  VeInput,
  VePhone,
  VeRadioGroup,
  VeSelect,
  VeTextArea,
} from "../..";

const SubSectionInputType = ({
  disabled = false,
  editData,
  data,
  item,
}: {
  disabled?: boolean;
  editData: any;
  data: any;
  item: any;
}) => {
  const isMobile = useMediaQuery("(max-width: 600px)");
  const didMountRef = useRef(false);
  const [numberFieldError, setNumberFieldError] = useState("");

  const fieldType = item?.fieldType;
  const options = item?.metadata?.options || [];

  let arrayValues: any[] = [];
  try {
    if (typeof options === "string") {
      arrayValues = JSON.parse(`[${options}]`);
    } else if (Array.isArray(options)) {
      arrayValues = options;
    }
  } catch (err) {
    arrayValues = [];
    console.error("Failed to parse options:", err);
  }
  const optionsType = arrayValues?.map((it: any) => {
    if (typeof it === "object" && it !== null && "label" in it) {
      return { label: String(it.label), value: String(it.value ?? it.label) };
    }
    return { label: it, value: it };
  });
  const [rows, setRows] = useState([Array(arrayValues.length).fill("")]);
  const handleInputChange = (
    rowIndex: number,
    colIndex: number,
    value: string,
  ) => {
    setRows((prevRows) => {
      const updatedRows = [...prevRows];
      const updatedRow = [...(updatedRows[rowIndex] ?? [])];
      updatedRow[colIndex] = value;
      updatedRows[rowIndex] = updatedRow;
      return updatedRows;
    });
  };
  const handleAddRow = () => {
    setRows((prevRows) => [...prevRows, Array(arrayValues.length).fill("")]);
  };
  useEffect(() => {
    if (fieldType === "Table" && item?.answer) {
      try {
        const parsedRows = JSON.parse(item.answer);
        if (Array.isArray(parsedRows)) {
          setRows(parsedRows);
        }
      } catch (err) {
        setRows([Array(arrayValues.length).fill("")]);
      }
    } else if (fieldType === "Table") {
      setRows([Array(arrayValues.length).fill("")]);
    }
  }, [item?.answer, fieldType, arrayValues.length]);
  // useEffect(() => {
  //   if (input === "Table") {
  //     if (didMountRef.current) {
  //       const stringified = JSON.stringify(rows);
  //       editData(data?.subsection, item?.id, stringified);
  //     } else {
  //       didMountRef.current = true; // Skip first render
  //     }
  //   }
  // }, [rows]);
  // useEffect(() => {
  //   if (input === "Table" && didMountRef.current) {
  //     const stringified = JSON.stringify(rows);
  //     if (stringified !== item?.answer) {
  //       editData(data?.subsection, item?.id, stringified);
  //     }
  //   } else {
  //     didMountRef.current = true;
  //   }
  // }, [rows]);
  useEffect(() => {
    if (fieldType !== "Table") return;
    if (!didMountRef.current) {
      didMountRef.current = true;
      return;
    }
    const handler = setTimeout(() => {
      const stringified = JSON.stringify(rows);
      if (stringified !== item?.answer) {
        editData(data?.subsectionLabel, item?.fieldId, stringified);
      }
    }, 400);
    return () => clearTimeout(handler);
  }, [
    rows,
    fieldType,
    data?.subsectionLabel,
    item?.fieldId,
    item?.answer,
    editData,
  ]);
  const handleDeleteRow = (rowIndex: number) => {
    setRows((prevRows) => prevRows.filter((_, index) => index !== rowIndex));
  };
  // Render based on fieldType
  switch (fieldType) {
    case "dropdown":
      const isMultiSelect = item?.metadata?.isMultiSelect;
      return (
        <VeBox sx={{ maxWidth: isMobile ? "100%" : "300px" }}>
          <VeSelect
            name=""
            label=""
            options={optionsType}
            multiple={isMultiSelect}
            disabled={disabled}
            placeholder={item?.metadata?.placeholdertext}
            value={
              isMultiSelect
                ? item?.answer && item.answer.trim()
                  ? item.answer.split(",").filter(Boolean)
                  : []
                : item?.answer && item.answer.trim()
                  ? item.answer
                  : null
            }
            onChangeData={
              isMultiSelect
                ? (val: any) =>
                    editData(
                      data?.subsectionLabel,
                      item?.fieldId,
                      val?.join(","),
                    )
                : (e: any) =>
                    editData(
                      data?.subsectionLabel,
                      item?.fieldId,
                      e.target.value,
                    )
            }
          />
        </VeBox>
      );

    case "radio":
      return (
        <VeBox sx={{ maxWidth: isMobile ? "100%" : "300px", paddingLeft: 1 }}>
          <VeRadioGroup
            name=""
            options={optionsType}
            customOnChange={(e: any) =>
              editData(data?.subsectionLabel, item?.fieldId, e.target.value)
            }
            selected={item?.answer || null}
            disabled={disabled}
            row={false}
          />
        </VeBox>
      );

    case "date":
      return (
        <VeBox sx={{ maxWidth: isMobile ? "100%" : "300px" }}>
          <VeDatePicker
            name=""
            label=""
            value={item?.answer ? item.answer : null}
            disabled={disabled}
            setDate={(dateString: string | null) => {
              editData(data?.subsectionLabel, item?.fieldId, dateString || "");
            }}
          />
        </VeBox>
      );

    case "Table":
      return (
        <VeBox sx={{ overflowX: "auto", width: "100%" }}>
          <VeBox
            minWidth={isMobile ? "100px" : `${optionsType.length * 150}px`}
            maxWidth={isMobile ? "350px" : "100%"}
            display="flex"
            flexDirection="column"
            gap="4px"
          >
            {/* Header Row */}
            <VeBox
              display="flex"
              flexDirection="row"
              gap="12px"
              width="100%"
              sx={{
                borderBottom: "1px solid #D5DBE1",
                paddingBottom: "4px",
                paddingTop: "4px",
              }}
            >
              {arrayValues?.map((header: string, index: number) => (
                <VeBox
                  key={index}
                  width="150px"
                  flexShrink={0}
                  paddingRight="8px"
                >
                  <VeTypography variant="label2StrongerSecondary">
                    {header}
                  </VeTypography>
                </VeBox>
              ))}
            </VeBox>
            {/* Dynamic Input Rows */}
            {rows?.map((row, rowIndex) => (
              <VeBox
                key={rowIndex}
                display="flex"
                flexDirection="row"
                gap="12px"
                width="100%"
                alignItems="center"
                sx={{
                  borderBottom:
                    rowIndex !== rows.length - 1 ? "1px solid #D5DBE1" : "none",
                  paddingBottom: "4px",
                  paddingTop: "4px",
                }}
              >
                {row?.map((cellValue, colIndex) => (
                  <VeBox
                    key={colIndex}
                    width="150px"
                    flexShrink={0}
                    paddingRight="8px"
                  >
                    {/* <VeInput
                      name={`input-${rowIndex}-${colIndex}`}
                      type="text"
                      disabled={disabled}
                      value={cellValue}
                      onChange={(e: any) =>
                        handleInputChange(rowIndex, colIndex, e.target.value)
                      }
                    /> */}
                    <VeTextArea
                      name={`input-${rowIndex}-${colIndex}`}
                      multiLineRows={1}
                      value={cellValue || ""}
                      disabled={disabled}
                      onChange={(e: any) =>
                        handleInputChange(rowIndex, colIndex, e.target.value)
                      }
                    />
                  </VeBox>
                ))}
                {!disabled && (
                  <VeBox onClick={() => handleDeleteRow(rowIndex)}>
                    <RemoveIcon />
                  </VeBox>
                )}
              </VeBox>
            ))}
            {!disabled && (
              <VeTypography
                variant="label3Brand"
                sx={{ cursor: "pointer" }}
                onClick={handleAddRow}
              >
                + Add
              </VeTypography>
            )}
          </VeBox>
        </VeBox>
      );

    case "numberField":
      const handleNumberChange = (e: any) => {
        const value = e.target.value;
        // Allow empty string or valid numbers (including decimals and negative numbers)
        if (value === "" || /^-?\d*\.?\d*$/.test(value)) {
          setNumberFieldError("");
          editData(data?.subsectionLabel, item?.fieldId, value);
        } else {
          setNumberFieldError("Please enter numeric values only.");
        }
      };

      return (
        <VeBox>
          <VeInput
            name=""
            label=""
            type="text"
            value={item?.answer || ""}
            disabled={disabled}
            onChange={handleNumberChange}
            placeHolder={item?.metadata?.placeholdertext || "Enter number"}
            error={!!numberFieldError}
            errorText={numberFieldError}
          />
        </VeBox>
      );

    case "phoneNumber":
      return (
        <VeBox sx={{ maxWidth: isMobile ? "100%" : "300px" }}>
          <VePhone
            name=""
            label="Enter Phone Number"
            value={item?.answer || ""}
            disabled={disabled}
            onChange={({ data: phoneData }: any) =>
              editData(data?.subsectionLabel, item?.fieldId, phoneData)
            }
            // placeHolder={
            //   item?.metadata?.placeholdertext || "Enter phone number"
            // }
          />
        </VeBox>
      );

    case "singleLineText":
      return (
        <VeInput
          name=""
          label=""
          type="text"
          value={item?.answer || ""}
          disabled={disabled}
          onChange={(e: any) =>
            editData(data?.subsectionLabel, item?.fieldId, e.target.value)
          }
          placeHolder={
            item?.metadata?.placeholdertext || "Write your answer here"
          }
        />
      );

    case "multiLineText":
      return (
        <VeTextArea
          multiLineRows={4}
          value={item?.answer || ""}
          disabled={disabled}
          onChange={(e: any) =>
            editData(data?.subsectionLabel, item?.fieldId, e.target.value)
          }
          placeHolder={
            item?.metadata?.placeholdertext || "Write your answer here"
          }
        />
      );

    case "singleCheckbox":
      return (
        <VeBox display="flex" flexDirection="row" alignItems="center">
          <Checkbox
            size="small"
            checked={item?.answer === "true" || item?.answer === true}
            disabled={disabled}
            onChange={(e: any) =>
              editData(
                data?.subsectionLabel,
                item?.fieldId,
                e.target.checked.toString(),
              )
            }
            sx={{
              color: "#D5DBE1",
              height: "15px",
              width: "15px",
              "&.Mui-checked": {
                color: "var(--vc-violet)",
              },
              padding: "0px",
            }}
            style={{ marginRight: 8 }}
          />
          <VeTypography variant="label2Secondary">
            {item?.fieldLabel}
          </VeTypography>
        </VeBox>
      );

    case "multiCheckbox":
      const selectedValues = item?.answer
        ? item.answer.split(",").filter(Boolean)
        : [];

      const isSelectionLimit = item?.metadata?.isSelectionLimit;
      const selectionLimit = item?.metadata?.selectionLimit
        ? parseInt(item?.metadata?.selectionLimit)
        : null;

      const handleCheckboxChange = (optionValue: string, checked: boolean) => {
        let updatedValues = [...selectedValues];
        if (checked) {
          // Check if selection limit is enabled and reached
          if (
            isSelectionLimit &&
            selectionLimit &&
            updatedValues.length >= selectionLimit
          ) {
            return; // Don't allow more selections
          }
          if (!updatedValues.includes(optionValue)) {
            updatedValues.push(optionValue);
          }
        } else {
          updatedValues = updatedValues.filter((val) => val !== optionValue);
        }
        editData(data?.subsectionLabel, item?.fieldId, updatedValues.join(","));
      };

      return (
        <VeBox display="flex" flexDirection="column" gap="8px">
          {optionsType.map((option: any, index: number) => (
            <VeBox
              key={index}
              display="flex"
              flexDirection="row"
              alignItems="center"
            >
              <Checkbox
                size="small"
                checked={selectedValues.includes(option.value)}
                disabled={
                  disabled ||
                  (isSelectionLimit &&
                    selectionLimit &&
                    !selectedValues.includes(option.value) &&
                    selectedValues.length >= selectionLimit)
                }
                onChange={(e: any) =>
                  handleCheckboxChange(option.value, e.target.checked)
                }
                sx={{
                  color: "#D5DBE1",
                  height: "15px",
                  width: "15px",
                  "&.Mui-checked": {
                    color: "var(--vc-violet)",
                  },
                  padding: "0px",
                }}
                style={{ marginRight: 8 }}
              />
              <VeTypography variant="label2Secondary">
                {option.label}
              </VeTypography>
            </VeBox>
          ))}
          {isSelectionLimit && selectionLimit && (
            <VeTypography variant="label4Secondary">
              {selectedValues.length}/{selectionLimit} selected
            </VeTypography>
          )}
        </VeBox>
      );

    default:
      // Default to multiLineText for unknown types
      return (
        <VeTextArea
          multiLineRows={4}
          value={item?.answer?.length > 0 ? item?.answer : null}
          disabled={disabled}
          onChange={(e: any) =>
            editData(data?.subsectionLabel, item?.fieldId, e.target.value)
          }
          placeHolder={
            item?.metadata?.placeholdertext || "Write your answer here"
          }
        />
      );
  }
};
export default SubSectionInputType;
